var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "productPage" }, [
    this.$store.state.webNavigator == "pc"
      ? _c("div", [
          _c(
            "div",
            { staticClass: "news-list" },
            [
              _c(
                "div",
                {
                  staticClass: "font44px",
                  staticStyle: {
                    margin: "40px 0 29px 0",
                    "text-align": "center"
                  }
                },
                [_vm._v("\n        全线产品\n      ")]
              ),
              _vm._l(_vm.productList, function(item, index) {
                return _c(
                  "div",
                  {
                    key: index,
                    staticClass: "news-list-bar displayIB pointEr",
                    class: (index + 1) % 4 == 0 ? "news-list-last-bar" : "",
                    on: {
                      click: function($event) {
                        return _vm.gotoInfo(item)
                      }
                    }
                  },
                  [
                    _c("div", [
                      _c("img", {
                        staticClass: "news-list-img",
                        attrs: {
                          src: _vm.httptype(item.themeImg),
                          alt: item.tag ? item.tag : "",
                          title: ""
                        }
                      })
                    ]),
                    _c("div", { staticClass: "news-list-Text displayIB" }, [
                      _c(
                        "p",
                        {
                          staticClass:
                            "font16px col33333 news-list-Tlt overflowText"
                        },
                        [_vm._v(_vm._s(item.title))]
                      )
                    ])
                  ]
                )
              })
            ],
            2
          )
        ])
      : _vm._e(),
    this.$store.state.webNavigator == "phone"
      ? _c("div", [
          _c(
            "div",
            { staticClass: "phoneProduct-list" },
            [
              _c(
                "div",
                {
                  staticClass: "font36phone",
                  staticStyle: {
                    margin: "40px 0 29px 0",
                    "text-align": "center"
                  }
                },
                [_vm._v("\n        全线产品\n      ")]
              ),
              _vm._l(_vm.productList, function(item, index) {
                return _c(
                  "div",
                  {
                    key: index,
                    staticClass: "phoneProduct-bar displayIB pointEr",
                    class: (index + 1) % 4 == 0 ? "news-list-last-bar" : "",
                    on: {
                      click: function($event) {
                        return _vm.gotoInfo(item)
                      }
                    }
                  },
                  [
                    _c("div", [
                      _c("img", {
                        staticClass: "phoneProduct-img",
                        attrs: {
                          src: _vm.httptype(item.themeImg),
                          alt: item.tag ? item.tag : "",
                          title: ""
                        }
                      })
                    ]),
                    _c("div", { staticClass: "phoneProduct-Text displayIB" }, [
                      _c(
                        "p",
                        {
                          staticClass:
                            "font24phone col33333 phoneProduct-Tlt overflowText"
                        },
                        [_vm._v(_vm._s(item.title))]
                      )
                    ])
                  ]
                )
              })
            ],
            2
          )
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9dcea08c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9dcea08c","hasScoped":true,"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/productList/productPage/productPage.vue
// module id = 999
// module chunks = 12